'use client';
import { ImageProps } from 'next/image';
import { useToggle } from '../../hooks';
import { Circle, CompanyIcon, ProfileIcon, ProfileImageRound, ProfileImageSquare } from './styles';
import { HandshakeOutlined } from '@mui/icons-material';

interface ProfilePictureProps extends Omit<ImageProps, 'src' | 'alt'> {
    readonly type?: 'company' | 'association' | 'administration' | 'user';
    readonly imageUrl?: string;
    readonly altText?: string;
    readonly size?: number;
    readonly kind?: 'round' | 'square';
}

const ProfilePicture = ({
    type = 'user',
    imageUrl,
    altText,
    role,
    size = 40,
    kind = 'round',
    ...props
}: ProfilePictureProps) => {
    const [hasError, toggleError] = useToggle();

    const getPlaceholderIcon = () => {
        switch (type) {
            case 'company':
                return <CompanyIcon />;
            case 'association':
                return <HandshakeOutlined />;
            case 'administration':
                return <HandshakeOutlined />;
            case 'user':
            default:
                return <ProfileIcon />;
        }
    };

    if (imageUrl && !hasError) {
        return kind === 'round' ? (
            <ProfileImageRound
                {...props}
                src={imageUrl}
                alt={altText ?? 'Profile Picture'}
                width={size}
                height={size}
                onError={() => toggleError(true)}
            />
        ) : (
            <ProfileImageSquare
                {...props}
                src={imageUrl}
                alt={altText ?? 'Profile Picture'}
                width={size}
                height={size}
                onError={() => toggleError(true)}
            />
        );
    } else return <Circle size={size}>{getPlaceholderIcon()}</Circle>;
};

export { ProfilePicture };
